<template>
  <section :class="isMobile ? 'repair-step mobile-repair-step' : 'repair-step'">
    <div class="title">审核</div>

    <div class="form" v-if="problemForm.rollbackReason">
      <div class="form-item">
        <a-space
          :size="isMobile ? 20 : 10"
          :direction="isMobile ? 'vertical' : 'horizontal'"
        >
          <div class="df">
            <div class="step-label">完成时间</div>
            <div class="data">
              <select-day-vue
                :defaultVal="machineInfo.auditTime"
                :disabled="true"
              ></select-day-vue>
            </div>
          </div>
          <!-- <div class="df">
            <div class="label">经手人</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.principal"
                placeholder="请输入经手人"
                allow-clear
                :disabled="!isEdit"
              ></a-input>
            </div>
          </div> -->
          <div class="df">
            <div class="step-label">回退原因</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.rollbackReason"
                :disabled="true"
              ></a-input>
            </div>
          </div>
        </a-space>
      </div>
    </div>

    <div class="footer df both-side">
      <a-button type="primary" @click="saveInfo" :disabled="!isEdit"
        >审核通过</a-button
      >
      <a-space :size="isMobile ? 10 : 50">
        <a-button @click="backPreStep" type="danger" :disabled="!backAuthority"
          >退回上一级</a-button
        >
      </a-space>
    </div>
  </section>

  <roll-back-modal-vue
    ref="rollBackModal"
    @rollBack="rollBack"
  ></roll-back-modal-vue>
</template>

<script>
import { defineComponent, reactive, ref, watch, computed } from "vue";
import {
  updateCustomerIssues,
  finalAudit,
  closedLoopRollback,
} from "@/request/view/repair";
import { Toast, uploadMedia } from "@/utils/index";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { showModal } from "../serve/modal";
import uploadImgVue from "./uploadImg.vue";
import uploadVideoVue from "./uploadVideo.vue";
import selectDayVue from "./selectDay.vue";
import rollBackModalVue from "./rollBackModal.vue";

export default defineComponent({
  components: { uploadImgVue, uploadVideoVue, selectDayVue, rollBackModalVue },
  props: {
    progress: Object,
    machine: Object,
    rollBackId: Number,
    rollbackReason: String,
    meta: Object,
  },
  setup(props, context) {
    const store = useStore();
    const isMobile = computed(() => store.state.isMonile);
    const router = useRouter();
    const back = () => {
      // router.go(-1);
      // router.replace("/repairequipment");
      context.emit("back");
    };
    const isEdit = computed(() => {
      if (store.getters.user) {
        return props.meta["/auditordateInfo"] && machineInfo.repairProcess == 5;
      }
      return false;
    });

    const backAuthority = computed(() => {
      if (store.getters.user) {
        return (
          props.meta["/auditordateInfo"] &&
          (machineInfo.repairProcess == 5 || machineInfo.repairProcess == -1)
        );
      }
      return false;
    });

    const uploadImg = ref();
    const uploadVideo = ref();
    const rollBackModal = ref();
    const machineInfo = reactive({
      id: null,
      repairProcess: null,
      auditTime: null,
    });
    const problemForm = reactive({
      processRecords: null,
      semiProducts: null,
      imgList: null,
      videoList: null,
      videoList: null,
      completeDate: null,
      parts: null,
      property: null,
      principal: null,
      id: null,
      rollbackReason: null,
      video: null,
      picture: null,
    });

    const saveInfo = async () => {
      showModal({
        title: "提示",
        toastText: "确认完成流程？",
        success: () => {
          finalAudit({
            id: machineInfo.id,
          })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              context.emit("updateMachineInfo");
              // context.emit("updateProcess", res.data);
              back();
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const nextStep = () => {
      showModal({
        title: "提示",
        toastText: "请先保存信息再确认到下一步流程？",
        success: () => {
          customerIssuesConfirm({
            customerIssuesId: problemForm.id,
          })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200 && res.message === "成功") {
                context.emit("updateMachineInfo");
                context.emit("updateProcess", res.data);
                back();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const rollBack = (e) => {
      closedLoopRollback({
        closedLoopId: props.rollBackId,
        rollbackReason: e,
      })
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          if (res.code === 200 && res.message === "回退成功") {
            rollBackModal.value.handleCancel();
            context.emit("updateMachineInfo");
            // context.emit("updateProcess", res.data);
            back();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const backPreStep = () => {
      rollBackModal.value.showModal();
      rollBackModal.value.setInputData(problemForm.rollbackReason);
    };

    const userDelectDay = (day) => {
      problemForm.completeDate = day;
    };

    const setProblemData = (data) => {
      problemForm.processRecords = data.processRecords;
      problemForm.principal = data.principal;
      problemForm.completeDate = data.completeDate;
      problemForm.id = data.id;
      problemForm.video = data.video;
      problemForm.picture = data.picture;
      problemForm.rollbackReason = data.rollbackReason;
      console.log(data, "final audit");
    };

    watch(
      () => props.progress,
      (val) => {
        setProblemData(val);
      },
      {
        immediate: true,
        deep: true,
      }
    );
    watch(
      () => props.machine,
      (val) => {
        machineInfo.id = val.id;
        machineInfo.repairProcess = val.repairProcess;
        machineInfo.auditTime = val.auditTime;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      machineInfo,
      problemForm,
      userDelectDay,
      saveInfo,
      nextStep,
      backPreStep,
      uploadImg,
      uploadVideo,
      rollBackModal,
      rollBack,
      isEdit,
      store,
      props,
      backAuthority,
      isMobile,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
